import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../asset/img/onpr_logo_2.png";
import axios from "axios";

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Veuillez entrer votre adresse email");
      return;
    }

    setIsLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await axios.post("forgot-password", { email });
      setMessage(response.data.message);
      setIsLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || "Une erreur est survenue");
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.greenHeader}>
        OFFICE NATIONAL DES PENSIONS ET RISQUES PROFESSIONNELS DES
        FONCTIONNAIRES, DES MAGISTRATS ET DES AGENTS DE L’ORDRE JUDICIAIRE
      </div>

      <div style={styles.mainContent}>
        <div style={styles.logoSection}>
          <img src={logo} alt="Logo ONPR" style={styles.logo} />
          <h1 style={styles.onprTitle}>ONPR</h1>
        </div>

        <div style={styles.container}>
          <div style={styles.card}>
            <div style={styles.header}>
              <h2 style={styles.title}>Mot de passe oublié</h2>
              <p style={styles.subtitle}>
                Entrez votre email pour recevoir un lien de réinitialisation
              </p>
            </div>

            {error && <div style={styles.errorBanner}>{error}</div>}
            {message && <div style={styles.successBanner}>{message}</div>}

            <form onSubmit={handleSubmit} style={styles.formContainer}>
              <div style={styles.formGroup}>
                <label htmlFor="email" style={styles.label}>
                  <svg
                    style={styles.icon}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  Adresse email
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="votre@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={styles.input}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#03a54f";
                    e.target.style.boxShadow =
                      "0 0 0 3px rgba(45, 95, 63, 0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{
                  ...styles.submitButton,
                  ...(isLoading ? styles.submitButtonDisabled : {}),
                }}
              >
                {isLoading ? (
                  <>
                    <span style={styles.spinner}></span>
                    Envoi en cours...
                  </>
                ) : (
                  "Envoyer le lien"
                )}
              </button>

              <div style={{ textAlign: "center", marginTop: "16px" }}>
                <Link to="/se-connecter" style={styles.backToLoginLink}>
                  Retour à la connexion
                </Link>
              </div>
            </form>
          </div>

          <div style={styles.footer}>
            <svg
              style={styles.shieldIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
            Vos données sont protégées et sécurisées
          </div>
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#03a54f";

const styles = {
  pageWrapper: {
    minHeight: "100vh",
    backgroundColor: "#f9fafb",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  greenHeader: {
    backgroundColor: primaryColor,
    color: "white",
    textAlign: "center",
    padding: "12px 20px",
    fontSize: "13px",
    fontWeight: "500",
    letterSpacing: "0.3px",
    textTransform: "uppercase",
  },
  mainContent: {
    padding: "40px 20px",
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    marginBottom: "40px",
  },
  logo: {
    height: "70px",
    objectFit: "contain",
  },
  onprTitle: {
    fontSize: "42px",
    fontWeight: "700",
    color: primaryColor,
    margin: 0,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "16px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    border: "1px solid #e5e7eb",
    padding: "40px",
    width: "100%",
    maxWidth: "500px",
  },
  header: {
    textAlign: "center",
    marginBottom: "32px",
    paddingBottom: "20px",
    borderBottom: "2px solid #2d5f3f",
  },
  title: {
    fontSize: "26px",
    fontWeight: "700",
    color: primaryColor,
    margin: "0 0 8px 0",
  },
  subtitle: {
    fontSize: "15px",
    color: "#6b7280",
    margin: 0,
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
  },
  icon: {
    width: "18px",
    height: "18px",
    color: primaryColor,
  },
  input: {
    width: "100%",
    padding: "12px 16px",
    fontSize: "15px",
    border: "2px solid #d1d5db",
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  errorBanner: {
    backgroundColor: "#ffebee",
    border: "1px solid #d32f2f",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "20px",
    color: "#c62828",
    fontSize: "14px",
    fontWeight: "500",
  },
  successBanner: {
    backgroundColor: "#ecfdf5",
    border: "1px solid #34d399",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "20px",
    color: "#065f46",
    fontSize: "14px",
    fontWeight: "500",
  },
  submitButton: {
    width: "100%",
    padding: "14px",
    fontSize: "16px",
    fontWeight: "600",
    color: "white",
    backgroundColor: primaryColor,
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 8px rgba(45, 95, 63, 0.2)",
    fontFamily: "inherit",
  },
  submitButtonDisabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
  spinner: {
    width: "20px",
    height: "20px",
    border: "3px solid rgba(255, 255, 255, 0.3)",
    borderTop: "3px solid white",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    display: "inline-block",
  },
  footer: {
    marginTop: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontSize: "13px",
    color: "#6b7280",
  },
  shieldIcon: {
    width: "16px",
    height: "16px",
    color: primaryColor,
  },
  backToLoginLink: {
    fontSize: "14px",
    color: primaryColor,
    textDecoration: "none",
    fontWeight: "600",
  },
};

export default ForgotPasswordScreen;
